import SingleSelect, { SingleSelectProps } from "designSystem/components/select/SingleSelect";
import { Box, FlexColumn } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import css from "./CustomViewOptions.module.css";

export interface SelectOptionProps {
	/** data-csi-automation value */
	dataCsiAutomation?: string;

	/** label of the SingleSelect box (localization resource to use to lookup text) */
	res: string;

	/** options of the SingleSelect box */
	selectProps: Omit<SingleSelectProps<ComponentItem>, "disableClearable" | "fullWidth">;
}

const SelectOption: FunctionComponent<SelectOptionProps> = observer((props) => {
	const { dataCsiAutomation, res, selectProps } = props;
	const csiAutomation = dataCsiAutomation ? { "data-csi-automation" : dataCsiAutomation } : {};

	return (
		<Box 
			{...csiAutomation}
			className={css.galleryContainer}
		>
			<FlexColumn className={css.optionLeft}>
				<SingleSelect
					{...selectProps}
					disableClearable
					fullWidth
					labelRes={res}
				/>
			</FlexColumn>
		</Box>
	);
});

export default SelectOption;